var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 76C58.9868 76 76 58.9868 76 38C76 17.0132 58.9868 0 38 0C17.0132 0 0 17.0132 0 38C0 58.9868 17.0132 76 38 76Z",
    fill: "url(#paint0_linear_29_47)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7227 40.7778L30.231 53.2564C30.231 53.2564 30.7947 54.4239 31.3983 54.4239C32.0018 54.4239 40.979 45.0848 40.979 45.0848L50.9619 25.803L25.8835 37.5567L25.7227 40.7778Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7009 43.978L30.8355 53.1759C30.8355 53.1759 30.4732 55.9943 33.2909 53.1759C36.1086 50.3576 38.8057 48.1843 38.8057 48.1843",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8032 41.2229L16.5293 38.2013C16.5293 38.2013 15.421 37.7516 15.7778 36.732C15.8513 36.5217 15.9995 36.3428 16.4428 36.0353C18.4977 34.603 54.4764 21.6713 54.4764 21.6713C54.4764 21.6713 55.4923 21.329 56.0914 21.5567C56.2396 21.6025 56.373 21.687 56.4779 21.8013C56.5828 21.9156 56.6554 22.0558 56.6883 22.2074C56.7531 22.4752 56.7801 22.7507 56.7688 23.026C56.7659 23.2641 56.7371 23.4848 56.7152 23.831C56.4961 27.3665 49.9386 53.7537 49.9386 53.7537C49.9386 53.7537 49.5462 55.2978 48.1405 55.3507C47.7951 55.3619 47.4509 55.3033 47.1286 55.1786C46.8062 55.054 46.5123 54.8656 46.2643 54.6249C43.5058 52.2521 33.9716 45.8447 31.8648 44.4355C31.8173 44.4031 31.7773 44.3609 31.7475 44.3118C31.7176 44.2626 31.6987 44.2076 31.6919 44.1505C31.6625 44.002 31.824 43.818 31.824 43.818C31.824 43.818 48.4255 29.0613 48.8673 27.5122C48.9015 27.3922 48.7723 27.333 48.5988 27.3855C47.4961 27.7912 28.3815 39.8622 26.2719 41.1944C26.12 41.2404 25.9595 41.2501 25.8032 41.2229Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_47",
    x1: 38,
    y1: 76,
    x2: 38,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramColored);
export default __webpack_public_path__ + "static/media/telegram_colored.9fc9b18dccbcc3ce0337e078168b801b.svg";
export { ForwardRef as ReactComponent };